import { render, staticRenderFns } from "./MisDispositivos.vue?vue&type=template&id=1f4964c6&"
import script from "./MisDispositivos.vue?vue&type=script&lang=js&"
export * from "./MisDispositivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports